import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { AuthService } from './services/auth.service';
import { Auth } from './models/auth.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})

/**
 * dir-w | backOffice
 * Application main component
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */
export class AppComponent implements OnInit, OnDestroy {
  protected isAuthenticated: boolean = true; //false;
  protected authUser: Auth | null = null;
  private subscription: Subscription;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _location: Location
  ) {
    this.subscription = this._authService.authSubject
      .asObservable()
      .subscribe((val) => {
        this.authUser = val;
        this.isAuthenticated = this.authUser === null ? false : true;
        // if user is authenticated and trying to access page before authenticate
        // redirect to dashboard
        if (
          this.isAuthenticated &&
          (this._location.path() === '/auth/signin' ||
            this._location.path() === '/auth/signup' ||
            this._location.path() === '/forgotPassword' ||
            this._location.path() === '/email/resendEmailVerification')
        ) {
          this._router.navigate(['/dashboard']);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this._authService.autoSignedIn();
  }
}
